module.exports = __webpack_public_path__ + "media/mypage/images/jisseki/jisseki07_pc-2078e178915a1e03918939fd98e6c3fe.jpg";